import { useRenderVTab } from "../hooks/useRenderVTabs";
import SettingContainerHeader from "./SettingContainerHeader";
import VerticalNavTabItem from "./VerticalNavTabItem";
import { useSelector } from "react-redux";
import React, { useRef, useEffect, useState, useCallback } from "react";
import APIRequest from "../../../../Services/commonAPIConsumer";
import { useDispatch } from "react-redux";
import useFetchLookupData from "../hooks/useFetchLookupData";
import {
  currentSelectedLanguage,
  restoreDefaults,
  retainTimeZoneData,
  setDefaultSettingsFor,
  setSearchedUserName,
  storeLookupData,
  setRPDLiteEnabled
} from "../../../../StateManagement/actions";
import {
  storeSettingsData,
  excludeControls,
  storeGatewaySettings,
} from "../../../../StateManagement/actions";
import WarnUnSaveChangesPopUp from "../../../Shared/UnSaveChangesWarnPopUp/WarnUnSaveChangesPopUp";
import useValidateSettings from "../hooks/useValidateSettings";
import useSubmitSettings from "../hooks/useSubmitSettings";
import Alert from "../../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
import { AppContext } from "../../../../AppContext";

export default function VerticalNavTabContainer() {
  const tabRefs = useRef([]);
  const settingContainerRef = useRef(null);
  const settingFor = useSelector((state) => state.settings.settingFor);
  const settings = useSelector((state) => state.settings);
  const vNavTabs = useRenderVTab();
  const userRole = localStorage.getItem("UserRole");
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const dispatch = useDispatch();
  const searchedUser = useSelector((state) => state.settings.searchedUser);
  const searchedCompany = useSelector(
    (state) => state.settings.searchedCompany
  );
  const LauncheslookupData = useSelector((state) => state.settings.lookupData);
  const timeZoneOffset = useSelector((state) => state.timeZone.timeZoneAbbrevation);
  const [isTabClickSearchForSupportAdmin, setIsTabClickSearchForSupportAdmin] =
    useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const { showConfirmationPopup, validateSettings } = useValidateSettings();
  const { fetchLookupData } = useFetchLookupData();
  const { submitChangedData: submitChangedDataFromHook, updateUserRoles } =
    useSubmitSettings();

  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const [tabMenuText, setTabMenuText] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const navigateToSelectedOnSubmitCancel = useRef("");

  const companyNameRef = useRef("");
  const userEmailRef = useRef("");
  const createTabState = () => {
    return {
      collapse: "",
      spanIcon: "",
      spanText: "",
    };
  };

  const [toggleAside, setToggleAside] = useState({
    Company: createTabState(),
    Personal: createTabState(),
    Admin: createTabState(),
  });
  console.log("timeZoneOffset in VNavTabContainer:", LauncheslookupData);
  const filteredTabs = vNavTabs.filter((tab) => {
    if (settingFor === "Company") {
      if ((!AppContext.ShowRPDLite && tab.title === "Storage") || (tab.title === "Storage" && settings.companyTab?.settingsData?.[0]?.configLevel === "User")) {
        return false;
      }
      return tab.tabtypes.includes("Company");
    } else if (settingFor === "User") {
      return (tab.title !== "Storage" && tab.tabtypes.some(
        (type) => type === "Company" || type === "Personal"
      ));
    } else if (settingFor === "Admin") {
      return tab.tabtypes.includes("Admin");
    }
    return false;
  });

  const updateRPDLiteReduxState = (changedSettings) => {
    const rpdLiteSetting = changedSettings?.find((setting) => setting?.type === "RPDLite");
    if (rpdLiteSetting) {
      const isEnabled = rpdLiteSetting.keyValue === true || rpdLiteSetting.keyValue === "true";
      dispatch(setRPDLiteEnabled(isEnabled));
    }
  };

  const getActiveTabSettings = async (
    tabMenuText,
    searchedUser,
    searchedCompany
  ) => {
    try {
      if (tabMenuText === "Contacts") {
        if ((searchedCompany && searchedCompany !== "") || (searchedUser && searchedUser !== "")) {
          setOpenLoader(true);
          let checkUrl = `${process.env.REACT_APP_API + process.env.REACT_APP_API_GetSettingDetails}?SettingFor=${settingFor === "Admin" ? "Company" : settingFor}&Lang=${localStorage.getItem("language")}&role=${userRole}`;
          if (searchedCompany && searchedCompany !== "" && searchedUser && searchedUser !== "") {
            checkUrl += `&company=${searchedCompany}&userEmail=${(searchedUser || "").toLowerCase()}`;
          } else if (searchedCompany && searchedCompany !== "") {
            checkUrl += `&company=${searchedCompany}`;
          } else if (searchedUser && searchedUser !== "") {
            checkUrl += `&userEmail=${(searchedUser || "").toLowerCase()}`;
          }
          const checkResponse = await APIRequest.GET("", checkUrl);
          if (checkResponse && checkResponse.errorMessage) {
            setOpenLoader(false);
            setAlertMsg(checkResponse.errorMessage);
            setAlertType("warning");
            setIsTabClickSearchForSupportAdmin(false);
            userEmailRef.current = "";
            companyNameRef.current = "";
            return checkResponse.errorMessage;
          }
        }
        setOpenLoader(false);
        setTabMenuText("Contacts");
        if (userRole === "RDocsSupportAdmin" && settingFor === "Company" && (searchedCompany !== "" || searchedUser !== "")) {
          setIsTabClickSearchForSupportAdmin(true);
        } else if (userRole === "RDocsSupportAdmin" && settingFor === "Company" && searchedCompany === "" && searchedUser === "") {
          setIsTabClickSearchForSupportAdmin(false);
        }
        userEmailRef.current = searchedUser || "";
        companyNameRef.current = searchedCompany || "";
        if (userRole === "RDocsCustomerAdmin") {
          companyNameRef.current = localStorage.getItem("Companyname");
        }
        return true;
      }
      searchedUser = searchedUser || "";
      searchedCompany = searchedCompany || "";

      let level = settingFor;
      setOpenLoader(true);
      if (settingFor === "Admin") {
        level = "Company";
      }

      if (
        settingFor === "Admin" &&
        tabMenuText === "Document"
      ) {
        level = "Global";
      }
      const user = (searchedUser || "").toLowerCase();
      let url = "";
      if (
        tabMenuText === "DirectSendDefaults"
      ) {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetGatewaySettingDetails
          }?SettingFor=${settingFor}&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      } else if (tabMenuText === "ContentSecurity") {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetContentSecuritySettingDetails
          }?SettingFor=${settingFor}&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      }
      else if (tabMenuText === "Storage") {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetStorageDetails
          }?SettingFor=${level}&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      }
      else if (tabMenuText === "Profile") {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetSettingDetails
          }?SettingFor=profile&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      } else {
        url = `${process.env.REACT_APP_API +
          process.env.REACT_APP_API_GetSettingDetails
          }?SettingFor=${level}&Lang=${localStorage.getItem(
            "language"
          )}&role=${userRole}`;
      }

      if (
        searchedUser &&
        searchedUser !== "" &&
        searchedCompany &&
        searchedCompany !== ""
      ) {
        url += `&company=${searchedCompany}&userEmail=${user}`;
      } else if (searchedCompany && searchedCompany !== "") {
        url += `&company=${searchedCompany}`;
      } else if (searchedUser && searchedUser !== "") {
        url += `&userEmail=${user}`;
      }
      let response = await APIRequest.GET("", url);
      if (response.statusText === "No data found") {
        setOpenLoader(false);
        dispatch(storeSettingsData({
          outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
          innerTabSelected: "General",
          Settings: []
        }));
        setTabMenuText("General");
        return;
      }

      if (response && response.errorMessage) {
        setOpenLoader(false);
        setAlertMsg(response.errorMessage);
        setAlertType("warning");
        setIsTabClickSearchForSupportAdmin(false);
        userEmailRef.current = "";
        companyNameRef.current = "";
        return response.errorMessage;
      }
      const timeZoneAbbrevation = response?.setting?.find(setting => setting.type === "TimeZone");
      dispatch(retainTimeZoneData(timeZoneAbbrevation));
      const abbrMatch = timeZoneAbbrevation?.keyValue?.match(/_(.*)$/);
      localStorage.setItem("timeZoneAbbrevation", abbrMatch?.[1] ?? "UTC");
      localStorage.setItem(
        "IsDirectSendDefaults",
        response.isDirectSendDefault
      );
      localStorage.setItem("IsContentSecurity", response.isContentSecurity == null ? false : response.isContentSecurity);
      if (tabMenuText === "DirectSendDefaults" && (response.isDirectSendDefault == null || response.isDirectSendDefault === "false")) {
        getActiveTabSettings(filteredTabs[0].title, searchedUser, searchedCompany);
        return;
      }
      if (tabMenuText === "ContentSecurity" && (response.isContentSecurity == null || response.isContentSecurity === "false")) {
        getActiveTabSettings(filteredTabs[0].title, searchedUser, searchedCompany);
        return;
      }
      setOpenLoader(false);
      const settingsData = {
        outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
        innerTabSelected: tabMenuText,
        Settings: [],
      };

      if (
        tabMenuText === "Profile" &&
        response?.userDetails
      ) {
        settingsData.Settings = response.userDetails;
      } else if (response?.setting) {
        const isDirectSend =
          tabMenuText === "DirectSendDefaults";
        const isContentSecurity =
          tabMenuText === "ContentSecurity";
        const mapSettings = (settings) =>
          settings.map((setting) => ({
            ...setting,
            prevValue: setting.keyValue,
            prevOverride:
              setting[isDirectSend || isContentSecurity ? "isOverride" : "overrideUserSetting"],
            prevLock: setting[isDirectSend || isContentSecurity ? "isLock" : "lockSetting"],
          }));
        if (
          tabMenuText === "DirectSendDefaults"
        ) {
          response.setting = response.setting.map((setting) => {
            setting.commonSettings = mapSettings(setting.commonSettings);
            setting.l1 = mapSettings(setting.l1);
            setting.l2 = mapSettings(setting.l2);
            setting.l3 = mapSettings(setting.l3);
            return setting;
          });
        }
        else if (tabMenuText === "ContentSecurity") {
          response.setting = response.setting.map((setting) => {
            setting.commonContentSecuritySetting = mapSettings(setting.commonContentSecuritySetting);
            setting.cipherText = mapSettings(setting.cipherText);
            setting.floatingText = mapSettings(setting.floatingText);
            return setting;
          });
        }
        else if (tabMenuText === "Storage") {
          response.setting = mapSettings(response.setting);
        }
        else {
          const landingPage =
            response.setting.find((s) => s.type === "LandingPage") || {};
          let landingPageValue = "";
          if (landingPage.keyValue.includes("_")) {
            landingPageValue = landingPage.keyValue.split("_")[1];
          } else {
            landingPageValue = "All Items";
          }
          const manageItem = {
            type: "LandingPage_ManageItem",
            keyValue: landingPageValue,
            overrideUserSetting: landingPage.overrideUserSetting,
            lockSetting: landingPage.lockSetting,
            id: landingPage.id,
          };
          response.setting.push(manageItem);
          response.setting = mapSettings(response.setting);
        }
        settingsData.Settings = response.setting;
        const controlsToExclude = [];

        controlsToExclude.push("MaxPagesPerRPD", "ImageResolution");

        // const maxViewsSetting = response.setting.find(
        //   (s) => s.type === "maxViewsPerDocument"
        // );
        // if (maxViewsSetting?.lockSetting === "true") {
        //   controlsToExclude.push("maxViewsPerDocument");
        // }

        dispatch(excludeControls({ value: controlsToExclude }));
      }

      if (settingsData.Settings) {
        dispatch(storeSettingsData(settingsData));
      }
      setTabMenuText(tabMenuText);
      if (userRole === "RDocsCustomerAdmin" && settingFor === "User") {
        setIsTabClickSearchForSupportAdmin(true);
      }

      if (
        userRole === "RDocsSupportAdmin" &&
        settingFor === "Company" &&
        (searchedCompany !== "" || searchedUser !== "")
      ) {
        setIsTabClickSearchForSupportAdmin(true);
      } else if (
        userRole === "RDocsSupportAdmin" &&
        settingFor === "Company" &&
        searchedCompany === "" &&
        searchedUser === ""
      ) {
        setIsTabClickSearchForSupportAdmin(false);
      }
      userEmailRef.current = searchedUser;
      companyNameRef.current = searchedCompany;
      if (userRole === "RDocsCustomerAdmin") {
        companyNameRef.current = localStorage.getItem("Companyname");
      }

      return true;
    } catch (error) {
      setOpenLoader(false);
      console.log(error);
    }
  };

  const isDataChanged = async (tabMenuText) => {
    dispatch(
      setDefaultSettingsFor({
        value: "Gateway",
      })
    );
    if (
      userRole === "RDocsSupportAdmin" &&
      (settingFor === "Company" || settingFor === "Admin") &&
      searchedUser === "" &&
      searchedCompany === ""
    ) {
      const isShowModal = showConfirmationPopup();

      if (isShowModal) {
        navigateToSelectedOnSubmitCancel.current = tabMenuText;
        setmodalIsOpen(true);
        return;
      }
      setIsTabClickSearchForSupportAdmin(false);
      const settingsData = {
        outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
        innerTabSelected: tabMenuText,
        Settings: [],
      };
      dispatch(storeSettingsData(settingsData));
      setTabMenuText(tabMenuText);
      return;
    }
    if (tabMenuText == "DefaultDocumentSettings") {
      try {
        fetchLookupData();
      }
      catch (err) {
        console.log(err);
      }
    }
    if (userRole === "RDocsCustomerAdmin" && settingFor === "Admin") {
      return;
    }



    const isShowModal = showConfirmationPopup();
    if (isShowModal) {
      navigateToSelectedOnSubmitCancel.current = tabMenuText;
      ///dispatch(setSearchedUserName({ searchText: "", companyName: "" }));
      //setTabMenuText(tabMenuText);
      setmodalIsOpen(true);
    } else {
      if (tabMenuText === "Users" || tabMenuText === "Document") {
        setIsTabClickSearchForSupportAdmin(true);
        const settingsData = {
          outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
          innerTabSelected: tabMenuText,
          Settings: [],
        };
        dispatch(storeSettingsData(settingsData));
        dispatch(setSearchedUserName({ searchText: "", companyName: "" }));
        setTabMenuText(tabMenuText);
        return;
      }
      await getActiveTabSettings(tabMenuText, searchedUser, searchedCompany);
    }
  };

  const submitChangedData = async () => {
    try {
      let result = {};
      setOpenLoader(true);
      if (
        userRole === "RDocsSupportAdmin" &&
        settingFor === "Admin" &&
        settings["AdminTab"]?.selectedTab === "Users"
      ) {
        result = await updateUserRoles();
        setIsTabClickSearchForSupportAdmin(false);
        //return;
      } else {
        const validateInputs = validateSettings();
        //setTabMenuText(navigateToSelectedOnSubmitCancel.current);
        if (validateInputs !== true) {
          setmodalIsOpen(false);
          setOpenLoader(false);
          setAlertMsg(validateInputs.message);
          setAlertType(validateInputs.type);
          return;
        }
        const tabMap = {
          Personal: "personalTab",
          Company: "companyTab",
          Admin: "AdminTab",
        };
        const settingsTabKey = tabMap[settingFor];
        const rpdLiteSetting = settings[settingsTabKey]?.settingsData?.find((setting) => setting?.type === "RPDLite" && setting?.isDataChanged);
        result = await submitChangedDataFromHook();
        if (result.success) {
          updateRPDLiteReduxState(
            rpdLiteSetting ? [rpdLiteSetting] : []
          );
        }
      }
      if (result.success) {
        setAlertType("sucess");
        //return;
      } else {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_FailedtoSaveSetting + "."
        );
        setAlertType("warning");
      }
      setOpenLoader(false);
    } catch (error) {
      console.log(error);
      setOpenLoader(false);
    }
    const activeTabIndex = filteredTabs.findIndex(
      (tab) => tab.title === navigateToSelectedOnSubmitCancel.current
    );
    const targetIndex = activeTabIndex >= 0 ? activeTabIndex : 0;

    tabRefs.current.forEach((tab) => {
      tab.classList.remove("active");
    });

    if (tabRefs.current[targetIndex]) {
      tabRefs.current[targetIndex].classList.add("active");
      getActiveTabSettings(
        filteredTabs[targetIndex].title,
        searchedUser,
        searchedCompany
      );
    } else if (tabRefs.current[0]) {
      tabRefs.current[0].classList.add("active");
      getActiveTabSettings(
        filteredTabs[0].title,
        searchedUser,
        searchedCompany
      );
    }
    setmodalIsOpen(false);
    navigateToSelectedOnSubmitCancel.current = "";
  };

  const handlerModelCancel = () => {
    setmodalIsOpen(false);
    dispatch(restoreDefaults());
    //setTabMenuText(navigateToSelectedOnSubmitCancel.current);
    const activeTabIndex = filteredTabs.findIndex(
      (tab) => tab.title === navigateToSelectedOnSubmitCancel.current
    );
    const targetIndex = activeTabIndex >= 0 ? activeTabIndex : 0;

    tabRefs.current.forEach((tab) => {
      tab.classList.remove("active");
    });

    if (tabRefs.current[targetIndex]) {
      tabRefs.current[targetIndex].classList.add("active");
      getActiveTabSettings(
        filteredTabs[targetIndex].title,
        searchedUser,
        searchedCompany
      );
    } else if (tabRefs.current[0]) {
      tabRefs.current[0].classList.add("active");
      getActiveTabSettings(
        filteredTabs[0].title,
        searchedUser,
        searchedCompany
      );
    }
    navigateToSelectedOnSubmitCancel.current = "";
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, [alertType]);

  useEffect(() => {
    if (tabRefs?.current?.length > 0) {
      tabRefs.current.forEach((tab) => {
        tab.classList.remove("active");
        tab.setAttribute("aria-selected", "false");
      });
      tabRefs.current[0].classList.add("active");
      tabRefs.current[0].setAttribute("aria-selected", "true");
      if (userRole === "RDocsSupportAdmin" && settingFor === "Company") {
        const settingsData = {
          outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
          innerTabSelected: filteredTabs[0].title,
          Settings: [],
        };
        dispatch(storeSettingsData(settingsData));
        setIsTabClickSearchForSupportAdmin(false);
        setTabMenuText(filteredTabs[0].title);
        return;
      } else if (userRole === "RDocsSupportAdmin" && settingFor === "User") {
        setIsTabClickSearchForSupportAdmin(true);
      }

      if (
        (userRole === "RDocsCustomerAdmin" ||
          userRole === "RDocsSupportAdmin") &&
        settingFor === "Admin"
      ) {
        const settingsData = {
          outerTabSelected: settingFor === "User" ? "Personal" : settingFor,
          innerTabSelected: 'Users',
          Settings: [],
        };
        dispatch(storeSettingsData(settingsData));
        return;
      }
      if (userRole === "RDocsCustomerAdmin" && (searchedUser || searchedCompany)) {
        dispatch(setSearchedUserName({ searchText: "", companyName: "" }));
        getActiveTabSettings(filteredTabs[0].title, "", "");
        return;
      }
      getActiveTabSettings(
        filteredTabs[0].title,
        searchedUser,
        searchedCompany
      );
    }
  }, [settingFor]);

  const renderVTab = filteredTabs.map((tab, index) => {

    return (
      <VerticalNavTabItem
        ref={(el) => el && (tabRefs.current[index] = el)}
        key={tab.id}
        spanIconclass={
          index === 0
            ? `icon-size ${toggleAside?.[settingFor]?.spanIcon}`
            : `icon-size${index} ${toggleAside?.[settingFor]?.spanIcon}`
        }
        spanTextclass={
          index === 0
            ? `tabtext ${toggleAside?.[settingFor]?.spanText}`
            : `tabtext${index} ${toggleAside?.[settingFor]?.spanText}`
        }
        active={tabMenuText === tab.title}
        isDataChanged={isDataChanged}
        {...tab}
      />
    );
  });

  let collapse = "";
  if (settingFor === "Company") collapse = "collapse1";
  else if (settingFor === "User") collapse = "collapse2";
  else collapse = "collapse3";

  const toggleAsideHandler = () => {
    setToggleAside((prev) => ({
      ...prev,
      [settingFor]: {
        ...prev[settingFor],
        collapse: prev?.[settingFor]?.collapse === collapse ? "" : collapse,
        spanIcon:
          prev?.[settingFor]?.spanIcon === "maticon-size" ? "" : "maticon-size",
        spanText:
          prev?.[settingFor]?.spanText === "icondisplay" ? "" : "icondisplay",
      },
    }));
  };

  return (
    <>
      {openLoader ? <LoadingSpinner /> : null}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist"
        isfromSeetting="true"
        resetTrigger={tabMenuText}></Alert>
      <div
        className={"tab-pane fade show active"}
        id="ex2-tabs"
        role="tabpanel"
      //aria-labelledby="ex2-tab"
      >
        <div className="row">
          <div
            className={`tableft-menu${settingFor === "User" ? "2" : settingFor === "Admin" ? "3" : ""
              } ${toggleAside?.[settingFor]?.collapse}`}>
            <div
              className={`tab-vertical${settingFor === "User" ? "2" : settingFor === "Admin" ? "3" : ""
                } tab-expand-xl ${toggleAside?.[settingFor]?.collapse}`}>
              <div
                className="nav flex-column nav-tabs text-left nav-pills-custom tab-vertical-content"
                id="v-tabs-tab"
                role="tablist"
                aria-orientation="vertical">
                <div className="expand-cricle" onClick={toggleAsideHandler}>
                  <span
                    className={`material-icons topn2 logo-name__icon ${toggleAside?.[settingFor]?.collapse}`}
                    id="collpase-icon2">
                    {toggleAside?.[settingFor]?.collapse === "collapse2"
                      ? "arrow_forward_ios"
                      : "arrow_back_ios"}
                  </span>
                </div>
                {renderVTab}
              </div>
            </div>
          </div>
          <SettingContainerHeader
            ref={settingContainerRef}
            tabMenuText={tabMenuText}
            getActiveTabSettings={getActiveTabSettings}
            isTabClickSearch={isTabClickSearchForSupportAdmin}
            collapseAside={toggleAside?.[settingFor]?.collapse}
            searchedInputData={{
              userEmail: userEmailRef.current,
              companyName: companyNameRef.current,
            }}
          />
        </div>
      </div>
      <WarnUnSaveChangesPopUp
        isOpen={modalIsOpen}
        onCancel={handlerModelCancel}
        onConfirm={submitChangedData}
      />
    </>
  );
}
